import React from 'react'
import { FlexRow } from '../FlexboxReusables/FlexItems'
import { Typography } from 'antd'
import styled from 'styled-components'
import { XCircle } from 'react-feather'

export const renderInvalidCertificate = () => (
  <>
    <FlexRow>
      <Typography.Title level={2}>Das Zertifikat ist NICHT gültig.</Typography.Title>
      <StyledXIcon size={30} />
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text strong>
        <p>Mögliche Gründe hierfür sind:</p>
        <ul>
          <li>Die Prüfung wurde nicht bestanden.</li>
          <li>Die Prüfung wurde nicht abgelegt.</li>
          <li>Die Verifikations-ID ist falsch.</li>
        </ul>
        <p>Bitte wenden Sie sich an den Kursleiter oder -Teilnehmer.</p>
      </Typography.Text>
    </FlexRow>
  </>
)


const StyledXIcon = styled(XCircle)`
  color: red;
  margin-left: 0.5em;
  margin-bottom: 0.5em;
`